import Tweet from "./Tweet";
import './TweetBoard.css';

const TweetBoard = ({ tweets }) => {
    return (
        <div className = "TweetBoard">
        {tweets.map(tweet => (
            <Tweet key = {tweet.id} name={tweet.name} handle={tweet.handle} profile_image={tweet.profile_image} message={tweet.message}/>
        ))}
        </div>
    );
}

export default TweetBoard
